import { combineReducers } from "@reduxjs/toolkit";
import dashboardSlice from "./dashboardSlice";

export default combineReducers({
  dashboard: dashboardSlice,
});
